<div class="h-100">
    <app-debug-overlay></app-debug-overlay>
    <app-spinner></app-spinner>
    <app-alert></app-alert>
    <lib-ngx-guided-tour></lib-ngx-guided-tour>

    <div class="toasts">
        <app-motd></app-motd>
        <app-profile-completion-reminder></app-profile-completion-reminder>
    </div>
    <app-nav>
        <!--
        Because of the Stacking Context, the action bar must be placed inside the nav component.
        Otherwise, the action bar will overlap the navigation because it creates a new stacking context of which
        the navbar is not a child.
        -->
        <app-configurator-action-bar></app-configurator-action-bar>
        <app-configurator-navigation></app-configurator-navigation>
        <app-elbridge-banner></app-elbridge-banner>
    </app-nav>
    <main #main id="main" [ngClass]="this.containerClassService.get()">
        <ui-view></ui-view>
    </main>
    <app-tour></app-tour>
</div>
